/* global axios */

export default {
  getOrders(accountId, params = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/orders`, { params });
  },

  getOrder(accountId, orderId) {
    return axios.get(`/api/v1/accounts/${accountId}/orders/${orderId}`);
  },

  updateOrder(accountId, orderId, data) {
    return axios.patch(`/api/v1/accounts/${accountId}/orders/${orderId}`, { order: data });
  },
};
